


<div class="popupu_card ci_popup_card pop_active_card"  *ngIf="show">

  <div class="popup_inner">

      <!-- <a href="javascript:void(0)" class="pc_close_btn" (click)="close()"><i class="icon-close"></i></a> -->

      <div class="ci_popup_txt_area">

          <p class="cpta_img"><img src="assets/images/alert_location.svg" alt=""></p>

          <p>Please enable the location and restart the app</p>
          
      </div>

      <div class="ci_popup_btn_area">

        <a href="javascript:void(0)" class="blue_btn" (click)="CallContinue()">Continue</a>

      </div>


  </div>

</div>  